export default "__VITE_ASSET__BRPFDvk8__"